import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})

/**
 * Footer Component
 */
export class FooterComponent implements OnInit {
  constructor() {}
  /***
   * Current year
   */
  year: number = new Date().getFullYear();

  ngOnInit(): void {}
}
